import {
  longTermAmpacityPlotDef,
  lastAmpacityDLRPlotDef,
  lastAmpacityAARPlotDef,
  activeShortTermAmpacityTablePlotDef,
  shortTermAmpacityPlotDef,
  belowNominalAmpacityTablePlotDef,
  powerlineCurrentPlotDef,
  lastPowerlineCurrentPlotDef,
} from "./defs"

export const powerlineInfoTabPlotDefs = [
  longTermAmpacityPlotDef,
  lastAmpacityAARPlotDef,
  lastAmpacityDLRPlotDef,
  belowNominalAmpacityTablePlotDef,
  shortTermAmpacityPlotDef,
  activeShortTermAmpacityTablePlotDef,
  powerlineCurrentPlotDef,
  lastPowerlineCurrentPlotDef,
]
